export default "/_next/static/images/2016-2x-45c5da10dc2862a10c2e5b3b9d025069.png";